<template>
  <div class="card">
    <AppAlert bold variant="danger">
      <template v-slot:icon>
        <svg
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="q-mr-xs"
        >
          <path
              d="M12 9V14"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
          <path
              d="M12.0001 21.41H5.94005C2.47005 21.41 1.02005 18.93 2.70005 15.9L5.82006 10.28L8.76006 5.00003C10.5401 1.79003 13.4601 1.79003 15.2401 5.00003L18.1801 10.29L21.3001 15.91C22.9801 18.94 21.5201 21.42 18.0601 21.42H12.0001V21.41Z"
              stroke="#FFF"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
          <path
              d="M11.9945 17H12.0035"
              stroke="#FFF"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
          />
        </svg>
      </template>
      {{ label }}
    </AppAlert>

    <p>
      <strong> {{ message.formatted.bold }} </strong>
      {{ message.normal }}
      <div v-if="showTel">
        <span><van-icon name="phone" color="dodgerblue" /><a style="color:dodgerblue" href="tel://0755-8332-2665">0755-83322665</a></span>
      </div>
    </p>
  </div>
</template>

<script>


// to use custom icons for alert, put the svg in the assets folder and import & use loadIcon method
// add the icon name to error object, below the message

import AppAlert from "@/components/AppAlert.vue";

export default {
  name: "DashCartridgeError",
  components: {
    AppAlert,
  },
  data() {
    return {
      error: {
        "no-cartridge": {
          label: this.$t('ProductInfo.CartridgeNotDetected'),
          message: {
            formatted: {
              bold: this.$t('ProductInfo.ReinsertTips'),
            },
            normal:
                this.$t('ProductInfo.ContactSupport')
          },
          // icon: "MY CUSTOM ICON"
        },
        "error-cartridge": {
          label: this.$t('ProductInfo.CartridgeNotRecognized'),
          message: {
            formatted: {
              bold: this.$t('ProductInfo.ReinsertTips')
            },
            normal: this.$t('ProductInfo.ContactSupport')
          },
        },
      },
    };
  },
  props: {
    variant: {
      type: String, // no-cartridge || error-cartridge
      required: true,
    },
  },
  computed: {
    showTel() {
      return process.env.VUE_APP_CUSTOMER === 'jzz'
    },
    label() {
      return this.error[this.variant].label;
    },
    message() {
      return this.error[this.variant].message;
    },
  },
};
</script>

<style lang="less" scoped>
.card {
  margin-top: 0.75rem;
  font-size: 14px;
  padding: 16px;
  margin: 16px;
  background: #333333;
  border-radius: 10px;

  & > * + * {
    margin-top: 1rem;
  }
}
</style>
